import Vue from 'vue'
import en from './en.json'

const DB_KEY = '588c5022f08c28a0bd3ed05f9c496bb469702606'

export const $t = key => (JSON.parse(window.localStorage.getItem(DB_KEY)).lang === 'zh' ? key : (en[key] || key))
Vue.prototype.$t = $t
